import React from 'react';
import { ClientModel } from '../models/person-model';
//import { ClericIndicator } from '../../pages/account-info/components/cleric-indicator';
import { headerIconStyles } from '../constants/theme/styles/components/header-icon-styles';

interface Props {
    client: ClientModel;
    clientNumberLabel: string;
    isDioApprover?: boolean;
    dioApproverTitle?: string;
}

export function NameClientNumber(props: Props) {
    const { client, clientNumberLabel, isDioApprover, dioApproverTitle } = props;
    const headerIconClasses = headerIconStyles();

    if (!client) return null;

    const middleNameString = client.middle_name ? ` ${client.middle_name} ` : ' ';
    const suffixString = client.suffix ? ` ${client.suffix}` : '';

    const displayName = client.first_name && client.last_name
        ? `${client.first_name || ''}${middleNameString}${client.last_name || ''}${suffixString}`
        : client.full_name;

    const displayContent = () => {
        if (isDioApprover) {
            return (
                <>
                    <div>
                        <div className={headerIconClasses.iconHeader}>
                            {/*<ClericIndicator shieldIcon />*/}
                            <h4>{displayName}</h4>
                        </div>
                        <p>{`${clientNumberLabel}: ${client.masked_person_client_nbr || client.masked_client_number}`} </p>
                    </div>
                    <div className={headerIconClasses.dioAdminHeader}> 
                    <h3>{dioApproverTitle}</h3>
                    </div>
                </>
            );
        }

        return (
            <div>
                <div className={headerIconClasses.iconHeader}>
                    {/*<ClericIndicator shieldIcon />*/}
                    <h4>{displayName}</h4>
                </div>
                <p>{`${clientNumberLabel}: ${client.masked_person_client_nbr || client.masked_client_number}`} </p>
            </div>
        );
    };

    return (
        displayContent()
    );
}

NameClientNumber.defaultProps = {
    isDioApprover: false,
    dioApproverTitle: '',
};